import IframeComponent from "src/components/IframeComponent";
import { runtimeConfig } from "src/services/runtimeConfig";

function SelfRegister() {
  return (
    <div className="row">
      <IframeComponent
        title="Self Register"
        src={`${runtimeConfig.classicUrl}/app/users/u-profile.adp`}
        width="100%"
        height="275px"
      />
    </div>
  );
}

export default SelfRegister;
